import { SvgIcon, SvgIconProps } from '@mui/material';

export default function InspectionsMenuIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 24 25" fill="none">
      <g fill="none">
        <path
          d="M8.25 23.2607H2.25C1.42157 23.2607 0.75 22.5892 0.75 21.7607V2.26074C0.75 1.43232 1.42157 0.760742 2.25 0.760742H12.879C13.2765 0.760827 13.6578 0.918724 13.939 1.19974L19.811 7.07174C20.092 7.35294 20.2499 7.73419 20.25 8.13174V8.26074"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 0.760742V6.76074C12.75 7.58917 13.4216 8.26074 14.25 8.26074H20.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.169 9.61914L6.037 12.4611C5.9065 12.6349 5.70703 12.7435 5.49025 12.7589C5.27347 12.7742 5.06069 12.6948 4.907 12.5411L3.75 11.3851"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.169 16.3691L6.037 19.2111C5.9065 19.3849 5.70703 19.4935 5.49025 19.5089C5.27347 19.5242 5.06069 19.4448 4.907 19.2911L3.75 18.1341"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 12.7607H15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.631 14.8802L15 22.5112L11.25 23.2612L12 19.5112L19.631 11.8802C20.457 11.0543 21.796 11.0543 22.622 11.8802L22.631 11.8892C23.4569 12.7151 23.4569 14.0542 22.631 14.8802Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
